// extracted by mini-css-extract-plugin
module.exports = {"commentOc":"styles_commentOc__27dUo","commentsOc":"styles_commentsOc__1CFMV","sentByEmail":"styles_sentByEmail__1AGLa","commentedAt":"styles_commentedAt__iz3mR"};